import { Pipe, PipeTransform } from '@angular/core';
import { GrpcCustomerExportInfo } from '@app/core/xprojector_backend/proto/xprojector.modulebms.export.pb';

@Pipe({
  name: 'bmsexportinfocustomerpipe'
})
export class BmsExportInfoCustomerPipe implements PipeTransform {

  constructor() {}

  transform(e: GrpcCustomerExportInfo[], showOnlyInvoiced : boolean, showBillingDisabled : boolean,
      showOnlySigned : boolean, excludeTariff : boolean, tariffOnly : boolean = false): GrpcCustomerExportInfo[] {

    // if (showOnlyInvoiced) {
    //   return e.filter(x => !x.invoiced && (showBillingDisabled || x.billingEnabled));
    // }

    return e.filter(x => (!showOnlyInvoiced
              || !x.invoiced)
              && (!showOnlySigned || !x.signed)
              && (!excludeTariff || x.invoiceDay <= 1)
              && (!tariffOnly || x.invoiceDay >= 2)
              && (showBillingDisabled || x.billingEnabled));
  }

}
